import { render, staticRenderFns } from "./InventoryMaterialRequest.vue?vue&type=template&id=40c2e372"
import script from "./InventoryMaterialRequest.vue?vue&type=script&lang=js"
export * from "./InventoryMaterialRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports